// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__zLCz2","error":"Textarea_error__1cnoR","readonly":"Textarea_readonly__1HO7Q","disabled":"Textarea_disabled__1VWx9"};